import { Analytics } from "@shared"

import CTAComponent from "./CTA"

const CTA = Analytics(CTAComponent, true)

export { CTA }
export default CTA
